/** En (cm) → min 120, bir üst 40'ın katı */
export const calculateRustikUsedCm = (width) => {
  const w = parseFloat(width) || 0;
  if (w <= 0) return '';
  const rounded = Math.ceil(w / 40) * 40;
  return String(Math.max(120, rounded));
};

/** Kullanılan cm'ye göre otomatik ayak sayısı */
export const calculateRustikAyakSayisi = (usedCm) => {
  const cm = parseFloat(usedCm) || 0;
  if (cm < 240) return 2;
  if (cm < 440) return 3;
  return 4;
};

export const calculateRustikRayLineTotal = (price, usedCm) => {
  const p = parseFloat(price) || 0;
  const cm = parseFloat(usedCm) || 0;
  return p * (cm / 100);
};

export const calculateRustikRayLineCost = (cost, usedCm) => {
  const c = parseFloat(cost) || 0;
  const cm = parseFloat(usedCm) || 0;
  return c * (cm / 100);
};

export const calculateRustikAyakExtraCost = (ekAyakSayisi, ayakUcretiCost) => {
  const ekAyak = parseFloat(ekAyakSayisi) || 0;
  const cost = parseFloat(ayakUcretiCost) || 0;
  if (ekAyak > 0 && cost > 0) return ekAyak * cost;
  return 0;
};

export const calculateRustikTotalPrice = (order) => {
  const qty = parseFloat(order.quantity) || 1;
  let subtotal = parseFloat(order.unitPrice) || 0;

  const ekAyak = parseFloat(order.ekAyakSayisi) || 0;
  const ayakUcreti = parseFloat(order.ayakUcreti) || 0;
  if (ekAyak > 0 && ayakUcreti > 0) {
    subtotal += ekAyak * ayakUcreti;
  }

  subtotal += parseFloat(order.mounting) || 0;

  const usedCm = parseFloat(order.usedCm) || 0;

  if (Array.isArray(order.rustikRaySecenekleri)) {
    order.rustikRaySecenekleri.forEach((item) => {
      subtotal += calculateRustikRayLineTotal(item.price, usedCm);
    });
  }

  if (Array.isArray(order.rustikAksesuarlar)) {
    order.rustikAksesuarlar.forEach((item) => {
      subtotal += (parseFloat(item.price) || 0) * (parseFloat(item.quantity) || 0);
    });
  }

  return { totalPrice: (subtotal * qty).toFixed(2) };
};

export const calculateRustikTotalCost = (order) => {
  const qty = parseFloat(order.quantity) || 1;
  let subtotal = parseFloat(order.baseUnitCost) || parseFloat(order.unitCost) || 0;
  subtotal += parseFloat(order.mountingCost) || 0;
  subtotal += calculateRustikAyakExtraCost(order.ekAyakSayisi, order.ayakUcretiCost);

  const usedCm = parseFloat(order.usedCm) || 0;

  if (Array.isArray(order.rustikRaySecenekleri)) {
    order.rustikRaySecenekleri.forEach((item) => {
      subtotal += calculateRustikRayLineCost(item.cost, usedCm);
    });
  }

  if (Array.isArray(order.rustikAksesuarlar)) {
    order.rustikAksesuarlar.forEach((item) => {
      subtotal += (parseFloat(item.cost) || 0) * (parseFloat(item.quantity) || 0);
    });
  }

  return (subtotal * qty).toFixed(2);
};

export const calculateRustikTotals = (order) => {
  const { totalPrice } = calculateRustikTotalPrice(order);
  const totalNum = parseFloat(totalPrice) || 0;
  const discountNum = parseFloat(order.discount) || 0;
  const discountedPrice = discountNum > 0
    ? (totalNum - totalNum * (discountNum / 100)).toFixed(2)
    : totalNum.toFixed(2);
  const totalCost = calculateRustikTotalCost(order);
  return { totalPrice, discountedPrice, totalCost };
};

export const cloneRustikExtras = (items = []) =>
  items.map((item) => ({
    ...item,
    cost: item?.cost ?? '',
    showCost: false
  }));

/** Firestore'a kayıt öncesi UI alanlarını temizle */
export const sanitizeRustikExtrasForSave = (items = []) =>
  items.map((item) => ({
    name: item?.name || '',
    price: item?.price ?? '',
    quantity: item?.quantity ?? '',
    cost: item?.cost ?? ''
  }));
